export const sk1Data = {
    name: 'sk1',
    baseUrl: "/samples/drums/sk1/",
    parts: ["kick", "snare", "hihat", "ohihat", "lowtom", "hitom"],
    samples: {
        C4: "kick.wav",
        D4: "snare.wav",
        E4: "hihat.wav",
        F4: "ohihat.wav",
        G4: "lowtom.wav",
        A4: "hitom.wav"
    }
}